<template>
  <div class="practice-stats">
    <div class="stats-title">练习情况统计</div>
    <div class="stats-content">
      <div class="stats-left">
        <div class="stat-item">
          <div class="stat-label">总练习时间</div>
          <div class="stat-value">{{hours}}h{{minutes}}min</div>
        </div>
        <div class="stat-item">
          <div class="stat-label">总答题数</div>
          <div class="stat-value">{{answerTotal}}</div>
        </div>
        <div class="stat-item">
          <div class="stat-label">正确答题数</div>
          <div class="stat-value">{{correctNum}}</div>
        </div>
      </div>
      <div class="stats-right">
        <!-- 圆环图 -->
        <div class="chart-placeholder">
          <div class="chart-circle">
            <CircularProgress :size="160"
                              :percentage="correctRate"
                              color="#1989fa"></CircularProgress>
          </div>
        </div>
        <div class="chart-legend">
          <div class="legend-item">
            <span class="legend-color correct"></span>
            <span class="legend-text">正确答题数</span>
          </div>
          <div class="legend-item">
            <span class="legend-color incorrect"></span>
            <span class="legend-text">总答题数</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CircularProgress from "@/components/CircularProgress/CircularProgress.vue";
import { exerciseStatistics } from "@/api/index.js";
export default {
  name: 'PracticeStats',
  components: {
    CircularProgress,
  },
  data() {
    return {
      hours: 0,
      minutes: 0,
      answerTotal: 0,
      correctRate: 0,
      correctNum: 0
    }
  },
  created() {
    this.getExerciseStatistics();
  },
  methods: {
    async getExerciseStatistics() {
      const { code, data } = await exerciseStatistics();
      if (code == 200) {
        this.hours = data.hours;
        this.minutes = data.minutes;
        this.answerTotal = data.answerTotal;
        this.correctNum = data.correctNum;
        this.correctRate = Number(((Number(data.correctRate) || 0) * 100).toFixed(0));
      }
    }
  },
}
</script>

<style lang="less" scoped>
.practice-stats {
  background: white;
  margin: 0 16px 20px;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  .stats-title {
    font-size: 16px;
    font-weight: 500;
    color: #333;
    margin-bottom: 20px;
  }

  .stats-content {
    display: flex;
    justify-content: space-between;
    // align-items: center;
  }

  .stats-left {
    width: 150px;

    .stat-item {
      margin-bottom: 18px;

      &:last-child {
        margin-bottom: 0;
      }

      .stat-label {
        font-size: 14px;
        color: #666;
        margin-bottom: 6px;
      }

      .stat-value {
        font-size: 20px;
        font-weight: bold;
        color: #333;
        position: relative;
      }
    }
  }

  .stats-right {
    flex: 1;
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;

    .chart-placeholder {
      margin-bottom: 12px;

      .chart-circle {
        width: 160px;
        height: 160px;
      }
    }

    .chart-legend {
      width: 160px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .legend-item {
        display: flex;
        align-items: center;
        font-size: 12px;

        .legend-color {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          margin-right: 3px;

          &.correct {
            background: #1989fa;
          }

          &.incorrect {
            background: #e5e5e5;
          }
        }

        .legend-text {
          color: #666;
        }
      }
    }
  }
}
</style>